export default __webpack_public_path__ + "pam.8768230b.png";